import * as net from 'util/Net';

export interface AdminSearchRecord {
  id: number;
  method: string; // HTTP verb
  created_at: string; // ISO 8601
  handle: string;
  profile_url: string;
  support_delegate_email: string;
  support_delegate_type: string | null;
  text: string;
}

export interface AdminSearchPaginatedResponse {
  records: Array<AdminSearchRecord>;
  nextToken: string;
}

export function doAdminSearchGet(data: {
  nextToken?: string;
  pageSize?: number;
  q?: string;
  until?: string;
  user_id?: string;
}): Promise<AdminSearchPaginatedResponse> {
  const organizationId = window.bootstrap?.organization_id;
  return net.getJSONPromise('/1/api/admin/search', {
    ...data,
    ...(organizationId != null ? {organization_id: organizationId} : {}),
  });
}

export interface UserAggregate {
  handle: string;
  read: number;
  write: number;
}

export interface UsageAggregate {
  date: string;
  users: Array<UserAggregate>;
}

export interface GetAggregateResponse {
  days: Array<UsageAggregate>;
  weeks: Array<UsageAggregate>;
  max_users: number;
}

export function getAdminAggregate(data: {
  year: number;
  month: number;
  organization_id?: string;
}): JQueryPromise<GetAggregateResponse> {
  const organizationId = window.bootstrap?.organization_id;
  return net.getJSON('/1/api/admin/aggregate/month', {
    ...data,
    ...(organizationId != null ? {organization_id: organizationId} : {}),
  });
}
